import type { QuickViewData } from "./types"
import {
  orderByLines,
  purchaseCard,
  STOCK_SOURCE_LABEL,
  stockCard,
  stockoutCard,
  type CardLine,
  type CardText,
} from "./lib/cardText"

function KeyNumber({ title, card, extra = [] }: { title: string; card: CardText; extra?: CardLine[] }) {
  return (
    <div className="flex flex-col gap-1 sm:px-3 sm:first:pl-0 sm:last:pr-0">
      <div className="text-xs font-medium text-foreground">{title}</div>
      <div className={`text-xl font-semibold tabular-nums ${card.alert ? "text-destructive" : "text-foreground"}`}>
        {card.value}
      </div>
      {card.lines.map((line) => (
        <div key={line} className="text-xs text-foreground">{line}</div>
      ))}
      {extra.map((line) => (
        <div key={line.text} className={`text-xs ${line.alert ? "text-destructive" : "text-foreground"}`}>{line.text}</div>
      ))}
    </div>
  )
}

// Stock on hand · Projected out of stock (with the order-by date and where
// the numbers come from) · Recommended PO. Side by side under a line, split by
// thin lines, in the panel's white top section.
export default function KeyNumbers({ data }: { data: QuickViewData }) {
  const { buying, average_sales, today } = data
  // The card's own numbers: the average, or the plan only without one.
  const source = data.stockout?.source
  const sourceLine = source ? [{ text: STOCK_SOURCE_LABEL[source], alert: false }] : []
  return (
    <div className="grid grid-cols-1 gap-3 border-t border-border pt-3 sm:grid-cols-3 sm:gap-0 sm:divide-x sm:divide-border">
      <KeyNumber title="Stock on hand" card={stockCard(buying.market.on_hand, data.stockout, average_sales)} />
      <KeyNumber
        title="Projected out of stock"
        card={stockoutCard(data.stockout, buying, today)}
        extra={[...orderByLines(data.order_by, today), ...sourceLine]}
      />
      <KeyNumber title="Recommended PO" card={purchaseCard(data.purchase, today)} />
    </div>
  )
}
